import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";

import AArsrapportFilterForm from "./AArsrapportFilterForm";

import {
  handleChange as handleChangeAction,
  handleChangeAll as handleChangeAllAction,
  handleChangeToInitState as handleChangeToInitStateAction,
} from "../../../actions/handleChangeAction";
import { getIleggelsestyper as getIleggelsestyperAction } from "../../../actions/ileggelsestyperActions";
import { getAArsrapport } from "../../../actions/rapporter/aarsrapportActions";

import {
  AArIsRequired,
  IleggelsestypeIsRequired,
} from "../../../constants/ErrorMessages";

const getAArValidationErrorText = (aar) => {
  if (aar) return null;
  return AArIsRequired;
};

const getIleggelsestyperValidationErrorText = (ileggelsestyper) => {
  if (ileggelsestyper && ileggelsestyper.length > 0) return null;
  return IleggelsestypeIsRequired;
};

function AArsrapportFilterFormContainer(ownProps) {
  const dispatch = useDispatch();
  const ileggelsestyper = useSelector((state) => state.ileggelsestyper);
  const aarsrapportFilterForm = useSelector(
    (state) => state.forms.aarsrapportFilterForm,
  );

  const handleChange = (variableName, value) =>
    dispatch(
      handleChangeAction(
        "RAPPORT_AARSRAPPORT_FILTER_FORM",
        variableName,
        value,
      ),
    );

  const getIleggelsestyper = useCallback(
    () => dispatch(getIleggelsestyperAction()),
    [dispatch],
  );

  const handleSubmit = (event, aar, ileggelsestyper) => {
    event.preventDefault();

    const aarValidationErrorText = getAArValidationErrorText(aar);
    const ileggelsestyperValidationErrorText =
      getIleggelsestyperValidationErrorText(ileggelsestyper);

    if (aarValidationErrorText) {
      handleChange("aarValidationErrorText", aarValidationErrorText);
    }
    if (ileggelsestyperValidationErrorText) {
      handleChange(
        "ileggelsestyperValidationErrorText",
        ileggelsestyperValidationErrorText,
      );
    }
    if (aarValidationErrorText || ileggelsestyperValidationErrorText) {
      return Promise.reject();
    }

    handleChange("aarValidationErrorText", "");
    handleChange("ileggelsestyperValidationErrorText", "");

    const yearNum = parseInt(aar, 10);
    const fraDato = new Date(Date.UTC(yearNum, 0, 1, 0, 0, 0, 0)).toISOString();
    const tilDato = new Date(
      Date.UTC(yearNum, 11, 31, 23, 59, 59, 999),
    ).toISOString();
    const ileggelsestypeIds = ileggelsestyper.map((i) => i.id);
    const ileggelsestypeNavn = ileggelsestyper.map((i) => i.navn);

    dispatch(
      handleChangeAllAction("RAPPORT_AARSRAPPORT_SUBMITTED_FORM", {
        aar: aarsrapportFilterForm.aar,
        ileggelsestypeNavn,
        submitTimestamp: new Date(),
      }),
    );
    return dispatch(getAArsrapport({ fraDato, tilDato, ileggelsestypeIds }));
  };

  return (
    <AArsrapportFilterForm
      {...ownProps}
      ileggelsestyper={ileggelsestyper}
      aarsrapportFilterForm={aarsrapportFilterForm}
      getIleggelsestyper={getIleggelsestyper}
      handleChange={(event) =>
        handleChange(event.target.name, event.target.value)
      }
      handleChangeIleggelsestype={(event) =>
        handleChange(event.target.name, event.target.value)
      }
      handleChangeAAr={(event) =>
        handleChange(event.target.name, event.target.value)
      }
      handleChangeToInitState={() =>
        dispatch(
          handleChangeToInitStateAction("RAPPORT_AARSRAPPORT_FILTER_FORM"),
        )
      }
      handleSubmit={handleSubmit}
    />
  );
}

export default AArsrapportFilterFormContainer;
